import vm from '@/main'

const i18n = param => vm.$t(`_staff.labelContact.${param}`)
export default () => {
  const column = [
    {
      label: i18n('name'),
      field: 'name',
    },
    {
      label: i18n('sex'),
      field: 'sex',
      dictField: 'sexName',
      formOption: {
        type: 'select',
        dictBizCode: 'gender',
        rules: 'required',
      },
    },
    {
      label: i18n('nationality'),
      field: 'nationality',
      formOption: {
        type: 'select',
        dictCode: 'nationality',
      },
    },
    {
      label: i18n('mobile'),
      field: 'mobile',
    },
    {
      label: i18n('email'),
      field: 'email',
      formOption: {
        rules: 'required|email',
      },
    },
    {
      label: i18n('adderss'),
      field: 'adderss',
    },
  ]
  return column
}
